import { Box, HStack } from '@chakra-ui/react';
import { BaseIcon, BasePopover, BaseToolbarButton, useStandardToast } from '@cks-internal/react-base';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useOverrideMccMutation } from '../api/useOverrideMccMutation';
import { useActivityQueryInvalidator } from '../../useActivityQueryInvalidator';

type Props = {
  activityId: number;
  headerText: string;
  buttonText: string;
  icon: IconDefinition;
  iconColor: string;
  disabled?: string[] | undefined;
};

export const OverrideMccButton = (props: Props) => {
  const overrideMccMutation = useOverrideMccMutation();
  const toast = useStandardToast();
  const activityQueryInvalidator = useActivityQueryInvalidator(props.activityId);

  const onOverrideMcc = async () => {
    await overrideMccMutation.mutateAsync({ activityId: props.activityId });
    toast.successToast('MCC Profile updated', 'MCC Profile has been updated for this booking.');
    await activityQueryInvalidator.invalidateAllQueriesForActivity();
  };

  return (
    <BasePopover
      onOk={onOverrideMcc}
      onCancel={() => {}}
      header={
        <Box fontSize={'md'} fontWeight={'bold'}>
          <HStack>
            <BaseIcon color={props.iconColor} icon={props.icon} />
            <Box>{props.headerText}</Box>
          </HStack>
        </Box>
      }
      trigger={
        <BaseToolbarButton disabled={props.disabled} icon={props.icon} iconProps={{ color: props.iconColor }}>
          {props.buttonText}
        </BaseToolbarButton>
      }></BasePopover>
  );
};
